<template>
  <content-with-sidebar
    v-if="post.id"
    class="cws-container cws-sidebar-right blog-wrapper"
  >

    <!-- content -->
    <div class="blog-detail-wrapper">
      <b-row>
        <!-- blogs -->
        <b-col cols="12">
          <b-card
            :img-src="post.image"
            img-top
            img-alt="Blog Detail Pic"
            :title="getTitle(post)"
          >
            <!-- eslint-disable vue/no-v-html -->
            <div
              class="blog-content"
              v-html="getBody(post)"
            />
            <!-- eslint-enable -->
            <div
              v-if="isAdmin()"
              class="text-right"
            >
              <hr class="my-2">
              <feather-icon
                class="cursor-pointer"
                icon="EditIcon"
                :title="$t('Update')"
                size="16"
                @click="update(post)"
              />
            </div>
          </b-card>
        </b-col>
        <!--/ blogs -->

      </b-row>
      <!--/ blogs -->
    </div>
    <!--/ content -->

    <!-- sidebar -->
    <div
      slot="sidebar"
      class="blog-sidebar py-2 py-lg-0"
    >
      <!-- input search -->
      <b-form-group class="blog-search">
        <b-input-group class="input-group-merge">
          <b-form-input
            id="search-input"
            v-model="search_query"
            :placeholder="$t('Search here')"
          />
          <b-input-group-append
            class="cursor-pointer"
            is-text
            @click="reloadList"
          >
            <feather-icon
              icon="SearchIcon"
            />
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
      <!--/ input search -->
      <!-- recent posts -->
      <div class="blog-recent-posts mt-3">
        <h6 class="section-label mb-75">
          {{ $t('Recent Posts') }}
        </h6>
        <b-media
          v-for="(recentpost,index) in posts"
          :key="recentpost.image"
          no-body
          :class="index? 'mt-2':''"
        >
          <b-media-aside class="mr-2">
            <b-link :to="{ name: isFront() ? 'post-front-view' : 'post-view' , params: { id: recentpost.id }}">
              <b-img
                :src="recentpost.image"
                width="100"
                rounded
                height="70"
              />
            </b-link>
          </b-media-aside>
          <b-media-body>
            <h6 class="blog-recent-post-title">
              <b-link
                class="text-body-heading"
                :to="{ name: isFront() ? 'post-front-view' : 'post-view', params: { id: recentpost.id }}"
                @click="reloadData(recentpost.id)"
              >
                {{ getTitle(recentpost) }}
              </b-link>
            </h6>
          </b-media-body>
        </b-media>
      </div>
      <!--/ recent posts -->
    </div>
  </content-with-sidebar>
</template>

<script>
import {
  BFormInput, BMedia, BMediaAside, BMediaBody, BImg, BLink,
  BFormGroup, BInputGroup, BInputGroupAppend, BCard, BRow, BCol,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ContentWithSidebar from '@core/layouts/components/content-with-sidebar/ContentWithSidebar.vue'
import { onUnmounted } from '@vue/composition-api'
import store from '@/store'
import postModule from '@/store/post'
import { isAdmin } from '@/auth/utils'

export default {
  components: {
    BFormInput,
    BMedia,
    BMediaAside,
    BMediaBody,
    BLink,
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BImg,
    ContentWithSidebar,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      search_query: '',
    }
  },
  computed: {
    post() {
      return this.$store.state[this.MODULE_NAME].post
    },
    posts() {
      return this.$store.state[this.MODULE_NAME].posts
    },
  },
  watch: {
    '$route.params.id': {
      handler(id) {
        this.reloadData(id)
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.reloadData(this.$route.params.id)
  },
  methods: {
    isAdmin,
    getTitle(post) {
      return post[`title_${this.$i18n.locale}`]
    },
    getBody(post) {
      return post[`body_${this.$i18n.locale}`]
    },
    reloadData(id) {
      this.$store.dispatch(`${this.MODULE_NAME}/get`, id)
      this.reloadList()
    },
    reloadList() {
      this.$store.dispatch(`${this.MODULE_NAME}/list`, {
        search: this.search_query,
        ordering: '-id',
        limit: 5,
      })
    },
    isFront() {
      return this.$route.meta.page === 'front'
    },
    update(post) {
      this.$router.push({ name: 'post-update', params: { id: post.id } })
    },
  },
  setup() {
    const MODULE_NAME = 'post-view'
    // Register module
    if (!store.hasModule(MODULE_NAME)) store.registerModule(MODULE_NAME, postModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(MODULE_NAME)) store.unregisterModule(MODULE_NAME)
    })

    return {
      MODULE_NAME,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-blog.scss';
</style>
